import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import ActiveSectionActions from "./ActiveSectionActions";
import typeCheckingStore from "data/util/typeCheckingStore";
import ContextedReduceStore from "./util/ContextedReduceStore";
import ActiveFormActions from "./ActiveFormActions";
import { recordIdType } from "data/util/typedefs";
import { IMPLICIT_TOP_OF_FORM_SECTION_NAME } from "data/meta/FormStore";

class ActiveSectionStore extends ContextedReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialContext() {
        return {
            key: null,
            id: null,
            currentSection: IMPLICIT_TOP_OF_FORM_SECTION_NAME,
        };
    }

    reduceContext(ctx, action) {
        switch (action.type) {
            case ActiveFormActions.START_RENDER:
                if (action.key !== ctx.key || action.id !== ctx.id) {
                    return this.getInitialContext();
                }
                return ctx;
            case ActiveSectionActions.SCROLL:
                if (ctx.key === action.key && ctx.id === action.id && ctx.currentSection === action.section) {
                    return ctx;
                }
                return {
                    ...ctx,
                    key: action.key,
                    id: action.id,
                    currentSection: action.section,
                };
            case ActiveSectionActions.JUMP_TO_SECTION:
                return {
                    ...ctx,
                    currentSection: action.section,
                };
            default:
                return ctx;
        }
    }

    getCurrentSection(context) {
        return this.getState(context).currentSection;
    }
}

ActiveSectionStore.contextTypes = {
    key: PropTypes.string,
    id: recordIdType,
    currentSection: PropTypes.string,
};

export default typeCheckingStore(new ActiveSectionStore());



// WEBPACK FOOTER //
// ./app/data/ActiveSectionStore.js